import { useAuth } from 'context/user'
import { useEntitlements } from 'context/plan'
import { useEventDetail } from 'hooks/useEventDetail'
import { eventAccessFor, EventAccess } from 'lib/eventAccess'

export const useEventAccess = (): EventAccess => {
  const { streamToolsUser } = useAuth()
  const { superuser } = useEntitlements()
  const { event } = useEventDetail()

  return eventAccessFor({
    members: event.members,
    userId: streamToolsUser?.userId,
    superuser
  })
}
